import { useMemo } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  x: string;
  y: number;
}

export const useTotalWorkingTime = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.total_work_time as DataType[];

  const chartData = useMemo<Partial<ChartProps>>(() => {
    if (data?.length) {
      const categories = data.map((item) => item.x);
      const series = [
        {
          name: t('Отработано часов'),
          data,
        },
      ];

      return {
        series,
        options: {
          chart: {
            type: 'bar',
            toolbar: { show: false },
            zoom: {
              enabled: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              distributed: true,
              borderRadius: 4,
              borderRadiusApplication: 'end',
              columnWidth: '8px',
            },
          },
          xaxis: {
            categories,
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: {
              style: {
                fontSize: '12px',
                colors: '#6b7280',
              },
            },
          },
          yaxis: {
            title: {
              text: t('Отработано часов'),
              style: { fontSize: '12px' },
            },
            labels: {
              style: {
                fontSize: '12px',
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
          },
          legend: {
            show: false,
          },
          colors: ['#c76df2'],
        },
      };
    }

    return { series: [], options: {} };
  }, [data, t]);

  return {
    label: 'Общее рабочее время',
    type: 'bar',
    wrapped: true,
    series: chartData.series,
    options: chartData.options,
  };
};
